export default __webpack_public_path__ + "static/proyecto2-6d9e7b0665b147a3ac88f22f842fb869.jpeg";